import * as React from "react";
import { Button, Margin, P, ErrorNotification } from "@ovotech/element";
import { useNavigate } from "react-router";

export const OopsPageContent = () => {
  const navigate = useNavigate();

  return (
    <>
      <ErrorNotification
        id="oops-error"
        title="Oops something has gone wrong"
        style={{ marginBottom: "4rem" }}
      >
        <P>Oops! Something went wrong. Please try again later.</P>
      </ErrorNotification>

      <Margin top={8} />
      <Button onClick={() => navigate(-1)} data-testid="try-again-button">
        Try again
      </Button>
    </>
  );
};
